var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.533 7.11c.015.213.015.426.015.64 0 6.505-4.949 14-13.995 14-2.787 0-5.375-.808-7.553-2.209.396.046.777.061 1.188.061 2.3 0 4.416-.777 6.106-2.102a4.928 4.928 0 0 1-4.599-3.413c.305.046.61.076.93.076a5.2 5.2 0 0 0 1.294-.167 4.92 4.92 0 0 1-3.944-4.83v-.06a4.952 4.952 0 0 0 2.223.624 4.918 4.918 0 0 1-2.193-4.098c0-.914.244-1.752.67-2.483a13.98 13.98 0 0 0 10.142 5.149 5.559 5.559 0 0 1-.122-1.127 4.918 4.918 0 0 1 4.92-4.921c1.415 0 2.695.594 3.593 1.554a9.682 9.682 0 0 0 3.122-1.188 4.907 4.907 0 0 1-2.162 2.711c.99-.106 1.949-.38 2.832-.761a10.577 10.577 0 0 1-2.467 2.544Z",
    fill: "#25282D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.955c6616f7be99d0da43427b6cbeb4f1.svg";
export { ForwardRef as ReactComponent };